import React from "react";
import "./styles.css";
import bloodCenterQuery from "../../../utils/queries/bloodCenterQuery";
import { Loading } from "../../Loader";
import icons from "../../../constants/icons";
import { Modal } from "../../Modal";
import CenterDetails from "./CenterDetails";
import HeaderSearch from "./HeaderSearch";
import { connect } from "react-redux";
import language from "../../../language";
import { Empty } from "../../Empty";
import { Button } from "../../Button";

// eslint-disable-next-line no-unused-vars
let copyData = [];

class Centers extends React.Component {
  state = {
    data: [],
    page: 1,
    limit: 10,
    selectedData: {},
  };

  componentDidMount = async () => {
    await this.getData(true);

    const { searchText } = this.props;

    if (searchText) {
      this.setState({ searchText });

      this.handleSearch(searchText);
    }
  };

  getData = async (isLoading, search = {}) => {
    try {
      const { page, limit } = this.state;
      const { defaultLanguage } = this.props;

      this.setState({ isLoading });

      const { data, count, totalRecords } = await bloodCenterQuery(defaultLanguage, {
        page,
        limit,
        ...search,
      });

      this.setState({
        data: data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handleShowModal(modal, modalTitle, selectedData) {
    this.setState({
      [modal]: true,
      modalTitle,
      selectedData,
    });
  }

  handleCloseModal = (modal) => {
    this.setState({ [modal]: false });
  };

  handleChange(e) {
    const searchText = e?.target?.value;

    this.setState({
      searchText,
    });
  }

  handleSearch() {
    this.getData(true, { q: this.state.searchText });
  }

  render() {
    return (
      <>
        <div style={{ marginBottom: "2rem" }}>
          <Button
            text={language[this.props.defaultLanguage].back}
            icon="keyboard_backspace"
            className="btn-default"
            onPress={() => (window.location.href = "/landing")}
          />
        </div>
        <div className="sites-landing-tabs-container">
          <HeaderSearch
            searchText={this.state.searchText}
            handleChange={this.handleChange.bind(this)}
            title={language[this.props.defaultLanguage].centers}
            description={
              language[this.props.defaultLanguage].centers_search_description
            }
            placeholder={language[this.props.defaultLanguage].search + "..."}
            handleSearch={this.handleSearch.bind(this)}
          />
          {this.state.isLoading ? (
            <center>
              <Loading />
            </center>
          ) : this.state.data.length > 0 ? (
            <>
              <div className="row">
                {this.state.data.map((item, i) => {
                  return (
                    <div key={i} className="col-md-4 mb-3">
                      <div
                        className="card centers"
                        onClick={
                          () => (window.location.href = `/sites/${item._id}`)
                          // this.handleShowModal("centerModal", item.name, item)
                        }
                      >
                        <div className="card-body">
                          <div className="center-icon-container">
                            <span className={process.env.REACT_APP_ICONS_TYPE}>
                              {icons.location}
                            </span>
                          </div>
                          <div className="center-info-container">
                            <h3 className="mb-1">{item.name}</h3>
                            <div className="address-container">
                              <p className="text-gray">
                                {item.address.province} {item.address.district}{" "}
                                {item.address.sector} {item.address.cell}{" "}
                                {item.address.village}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <Empty
              description={`${
                language[this.props.defaultLanguage].no_data_found
              }: ${this.state.searchText}`}
            />
          )}
        </div>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "centerModal")}
          show={this.state.centerModal}
          title={this.state.modalTitle}
        >
          <CenterDetails center={this.state.selectedData} />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Centers);
